/* eslint-disable max-lines-per-function */
import type { ReactNode } from 'react'
import classNames from 'classnames'
import {
  ANDROID_ONE_APP_LINK,
  CDN_DOMAIN,
  IOS_ONE_APP_LINK,
} from '@/root/constants'
import { StencilCDNImage } from '@/components/Common/StencilImage'
import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'
import {
  EN_HOME_APP_STORE_CLICK,
  EN_HOME_PLAY_STORE_CLICK,
} from '@/root/utils/common/web/gtm-events/eventsList'
import { INDSTOCKS_HOST } from '@/root/constants/common'
import { useRouter } from 'next/router'
import { getLineOfBusiness } from '@/hooks/analytics/use-gtm-event'

const Wrapper: React.FC<{
  children: ReactNode
}> = ({ children }) => {
  return <div className="w-32 cursor-pointer md:w-40">{children}</div>
}
export default function MobileStores({
  links = true,
  diff = false,
  dontShowDownloadAppImages,
  cssStyle,
  host,
}: {
  links?: boolean
  dontShowDownloadAppImages?: boolean
  cssStyle?: string
  diff?: boolean
  host?: string
}) {
  const router = useRouter()
  const pushEvent = useAnalyticsEvent()
  if (dontShowDownloadAppImages) {
    return null
  }

  const isIndStocks = host === INDSTOCKS_HOST

  if (isIndStocks) {
    return (
      <div
        className={classNames(
          'flex flex-col items-end space-x-4 space-y-2 md:flex-row',
          cssStyle,
        )}
      >
        <Wrapper>
          {links ? (
            <button
              type="button"
              className="cursor-pointer border-0 bg-transparent p-0"
              onClick={e => {
                e.stopPropagation()
                const url =
                  'https://apps.apple.com/us/app/flash-trading-app-by-indstocks/id6474673274'
                pushEvent({
                  mixpanelEventPayload: {
                    eventName: EN_HOME_APP_STORE_CLICK,
                    payload: {
                      source: getLineOfBusiness(router.asPath),
                      lob: getLineOfBusiness(router.asPath),
                      isIndStocks,
                    },
                  },
                })
                router.push(url)
              }}
              title="Download INDmoney app from App Store"
            >
              <StencilCDNImage
                src={`${CDN_DOMAIN}/cdn/images/fe/appstore-ico.svg`}
                alt="Download INDmoney app from App Store"
                width={2500}
                height={750}
              />
            </button>
          ) : (
            <StencilCDNImage
              src={`${CDN_DOMAIN}/cdn/images/fe/appstore-ico.svg`}
              alt="Download INDmoney app from App Store"
              width={2500}
              height={750}
              className="cursor-default"
            />
          )}
        </Wrapper>
        <Wrapper>
          {links ? (
            <button
              type="button"
              className="cursor-pointer border-0 bg-transparent p-0"
              onClick={e => {
                e.stopPropagation()

                pushEvent({
                  mixpanelEventPayload: {
                    eventName: EN_HOME_PLAY_STORE_CLICK,
                    payload: {
                      source: getLineOfBusiness(router.asPath),
                      lob: getLineOfBusiness(router.asPath),
                      isIndStocks,
                    },
                  },
                })

                router.push(
                  'https://play.google.com/store/apps/details?id=com.indmoney.indstocks',
                )
              }}
              title="Download INDmoney app from Google Play"
            >
              <StencilCDNImage
                src={`${CDN_DOMAIN}/cdn/images/fe/playstore-ico.svg`}
                alt="Download INDmoney app from Google Play"
                width={2500}
                height={750}
              />
            </button>
          ) : (
            <StencilCDNImage
              src={`${CDN_DOMAIN}/cdn/images/fe/playstore-ico.svg`}
              alt="Download INDmoney app from Google Play"
              width={2500}
              height={750}
              className="cursor-default"
            />
          )}
        </Wrapper>
      </div>
    )
  } else
    return (
      <div
        className={classNames(
          'flex flex-col items-end space-x-4 space-y-2 md:flex-row',
          cssStyle,
        )}
      >
        <Wrapper>
          {links ? (
            <button
              type="button"
              className="cursor-pointer border-0 bg-transparent p-0"
              onClick={e => {
                e.stopPropagation()
                const url = diff
                  ? IOS_ONE_APP_LINK
                  : 'https://indmoney.onelink.me/MgHh/s9utdn0x'

                pushEvent({
                  mixpanelEventPayload: {
                    eventName: EN_HOME_APP_STORE_CLICK,
                    payload: {
                      source: getLineOfBusiness(router.asPath),
                      lob: getLineOfBusiness(router.asPath),
                    },
                  },
                })

                router.push(url)
              }}
              title="Download INDmoney app from App Store"
            >
              <StencilCDNImage
                src={`${CDN_DOMAIN}/cdn/images/fe/appstore-ico.svg`}
                alt="Download INDmoney app from App Store"
                width={160}
                height={47}
              />
            </button>
          ) : (
            <StencilCDNImage
              src={`${CDN_DOMAIN}/cdn/images/fe/appstore-ico.svg`}
              alt="Download INDmoney app from App Store"
              width={160}
              height={47}
              className="cursor-default"
            />
          )}
        </Wrapper>
        <Wrapper>
          {links ? (
            <button
              type="button"
              className="cursor-pointer border-0 bg-transparent p-0"
              onClick={e => {
                e.stopPropagation()
                const url = diff
                  ? ANDROID_ONE_APP_LINK
                  : 'https://indmoney.onelink.me/MgHh/s9utdn0x'

                pushEvent({
                  mixpanelEventPayload: {
                    eventName: EN_HOME_PLAY_STORE_CLICK,
                    payload: {
                      lob: getLineOfBusiness(router.asPath),
                      source: getLineOfBusiness(router.asPath),
                      isIndStocks,
                    },
                  },
                })

                router.push(url)
              }}
              title="Download INDmoney app from Google Play"
            >
              <StencilCDNImage
                src={`${CDN_DOMAIN}/cdn/images/fe/playstore-ico.svg`}
                alt="Download INDmoney app from Google Play"
                width={160}
                height={47}
              />
            </button>
          ) : (
            <StencilCDNImage
              src={`${CDN_DOMAIN}/cdn/images/fe/playstore-ico.svg`}
              alt="Download INDmoney app from Google Play"
              width={160}
              height={47}
              className="cursor-default"
            />
          )}
        </Wrapper>
      </div>
    )
}
